export enum AdminModalType {
  IMAGE_UPLOAD_CANCEL = 'IMAGE_UPLOAD_CANCEL', // 이미지 업로드 페이지 상단 '취소'버튼 클릭하여 페이지 떠날 시
  IMAGE_EDIT_CANCEL = 'IMAGE_EDIT_CANCEL', // 이미지 정보 수정 페이지 상단 '취소'버튼 클릭하여 페이지 떠날 시

  IMAGE_DELETE_CONFIRM = 'IMAGE_DELETE_CONFIRM', // 이미지 삭제 버튼 클릭시 확인

  IMAGE_UPLOAD_REQUEST_FAIL = 'IMAGE_UPLOAD_REQUEST_FAIL', // 이미지 생성/편집 관련 요청 실패
  IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS', // 이미지 생성 성공
  IMAGE_EDIT_SUCCESS = 'IMAGE_EDIT_SUCCESS', // PATCH 이미지 또는 오류 리포트 성공
  IMAGE_FILE_TYPE_ERROR = 'IMAGE_FILE_TYPE_ERROR', // 이미지 파일 타입 에러
  IMAGE_FILE_SIZE_ERROR = 'IMAGE_FILE_SIZE_ERROR', // 이미지 파일 용량 에러
  OMIT_REQUIRED_INPUT = 'OMIT_REQUIRED_INPUT', // 필수 입력란 누락

  //삭제된 이미지 관련
  RESTORE_CONFIRM = 'RESTORE_CONFIRM',
  RESTORE_STANDARD_IMAGE_SUCCESS = 'RESTORE_STANDARD_IMAGE_SUCCESS',
  RESTORE_ADULTS_ONLY_IMAGE_SUCCESS = 'RESTORE_ADULTS_ONLY_IMAGE_SUCCESS',
  RESTORE_FAIL = 'RESTORE_FAIL',
  HARD_DELETE_CONFIRM = 'HARD_DELETE_CONFIRM',
  HARD_DELETE_FAIL = 'HARD_DELETE_FAIL',

  //회원 관리 관련
  USER_DELETE_CONFIRM = 'USER_DELETE_CONFIRM',
  USER_DELETE_FAIL = 'USER_DELETE_FAIL',
  USER_CREATE_CANCEL = 'USER_CREATE_CANCEL',
  USER_CREATE_FAIL = 'USER_CREATE_FAIL',
  USER_EDIT_CANCEL = 'USER_EDIT_CANCEL',
  USER_EDIT_FAIL = 'USER_EDIT_FAIL',
  USER_UPSERT_SUCCESS = 'USER_UPSERT_SUCCESS'
}
